import * as React from 'react';
import * as Tabs from '@radix-ui/react-tabs';
import { cn } from '@/lib/utils';

export const Abas = Tabs.Root;

export function ListaAbas({
  className,
  ...props
}: React.ComponentPropsWithoutRef<typeof Tabs.List>): JSX.Element {
  return (
    <Tabs.List
      className={cn('flex items-center gap-1 border-b border-borda', className)}
      {...props}
    />
  );
}

export function Aba({
  className,
  ...props
}: React.ComponentPropsWithoutRef<typeof Tabs.Trigger>): JSX.Element {
  return (
    <Tabs.Trigger
      className={cn(
        'relative min-h-[44px] px-3.5 text-[13.5px] font-semibold text-textoFraco transition-colors',
        'hover:text-texto data-[state=active]:text-primaria',
        'after:absolute after:inset-x-1 after:bottom-[-1px] after:h-[2.5px] after:rounded-full after:bg-transparent after:transition-colors',
        'data-[state=active]:after:bg-gradient-to-r data-[state=active]:after:from-primaria data-[state=active]:after:to-primaria-dois',
        className,
      )}
      {...props}
    />
  );
}

export function ConteudoAba({
  className,
  ...props
}: React.ComponentPropsWithoutRef<typeof Tabs.Content>): JSX.Element {
  return <Tabs.Content className={cn('pt-4 focus-visible:outline-none', className)} {...props} />;
}
